<section class="meetings-details h-100">
  <as-split direction="horizontal" [dir]="'ltr'">
    <as-split-area class="ninja-content-primary" [size]="30">
      <div class="me-4">
        <div class="pt-4">
          <i-title [text]="'sidebar.points' | translate" level="1" [buttons]="buttons()"></i-title>

        </div>
        <div class="blockButtonSearch d-flex align-items-center justify-content-between tac-search-field w-100 mt-"
          *ngIf="activeModeSearch !== 'serviceSearch' && advancedSearchDatas === null">
          <div class="divForAbsolute w-100 me-2">
            <span class="d-flex align-items-center p-input-icon-left w-100">
              <i class="pi pi-search"></i>
              <input
                pTooltip="Vous pouvez ajouter dans votre recherche && pour faire un ET ainsi que || pour faire un OU"
                #pointSearchInput type="text"
                class="form-control super-compos-search-field pe-5 ps-5 w-100 advSearch__field"
                [placeholder]="'sidebar.points' | translate" [(ngModel)]="pointSearch" (keydown.enter)="searchPoint()"
                (ngModelChange)="onPointSearchChange($event)" (focus)="onFocusInput = true"
                (blur)="onFocusInput = false" />
            </span>
            <div class="buttonAbsolute">
              <div class="blockButtonDropDown">
                <super-button #searchButton [text]="dropdownLabel" icon="bi bi-arrows-vertical" iconPosition="right"
                  styleClass="gray tac-nowrap overwirteClassButton advSearch__btn tac-dropdown-search dropdownPosition marginForAbsolute"
                  (click)="showOverlayDropdown = !showOverlayDropdown; onFocusInput = !onFocusInput">
                </super-button>
                <div class="dropdown-menu dropdownPosition" [ngClass]="{ 'd-block': showOverlayDropdown }"
                  data-bs-auto-close="outside">
                  <a class="dropdown-item" data-bs-auto-close="outside" *ngIf="dropdownValue !== 'Titre'"
                    (click)="emptySearch();onClickDropdownInput('Titre')">
                    <div class="d-flex align-items-center">
                      <span>Titre</span>
                    </div>
                  </a>
                  <a class="dropdown-item" data-bs-auto-close="outside" *ngIf="dropdownValue !== 'Titre + Contenus'"
                    (click)="emptySearch();onClickDropdownInput('Titre + Contenus')">
                    <div class="d-flex align-items-center">
                      <span>Titre + Contenus</span>
                    </div>
                  </a>
                  <a class="dropdown-item" data-bs-auto-close="outside" *ngIf="dropdownValue !== 'Id'"
                    (click)="emptySearch();onClickDropdownInput('Id')">
                    <div class="d-flex align-items-center">
                      <span>Id</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <idel-layout-toggler [(layout)]="currentLayout" (layoutChange)="changeDisplay()"></idel-layout-toggler>
        </div>

        <div class="alert alert-primary d-flex align-items-center justify-content-between my-2" *ngIf="searchExist">
          {{ 'info.resultBasedOnAdvancedSearch' | translate }}
          <i-button [text]="'btn.reset' | translate" styleClass="blue" (click)="reset()"></i-button>
        </div>
        <div style="max-height: 75dvh; overflow-y: auto; padding-right: .75rem;" [class.mt-2]="!searchExist">

          <idel-points-categories [categories]="pointsCategories()"
            [defaultCategory]=" pointsCategories().length ? pointsCategories()[0][0] : null"></idel-points-categories>
        </div>
      </div>
    </as-split-area>
    <as-split-area [size]="70" class="ninja-content-secondary">
      <div class="ms-4 mt-4">
        @if(showAdvancedSearch()) {
        <idel-points-advanced-search (onCancel)="onToggleAdvancedSearch()" (onSearch)="searchPoints($event)"
          (onLoad)="onLoadSavedSearch($event)" (refreshDashboard)="onRefreshDashboard()"></idel-points-advanced-search>
        }@else {
        <router-outlet></router-outlet>
        }
      </div>
    </as-split-area>
  </as-split>
</section>